import type { MessageHandlerDeps } from '../../message-handler-deps.js';
import { getSessionWorkingTreeChangeDetailsCoalesced } from './coalesce-list-changes.js';
import { parseSessionGitChangesParams } from './session-git-changes-params.js';

type SessionGitReply = (
  payload: Record<string, unknown>,
  encryptedFields?: readonly string[],
) => void;

export async function handleSessionGitListChangesAction(
  deps: MessageHandlerDeps,
  msg: { sessionId: string } & Record<string, unknown>,
  reply: SessionGitReply,
): Promise<void> {
  const changes = parseSessionGitChangesParams(msg);
  const { repoRelPath: repoRel, view, commitSha, recentCommitsLimit } = changes;
  if (view === 'commit') {
    if (!repoRel || !commitSha) {
      reply({
        ok: false,
        error: 'changes.repoRelPath and changes.commitSha are required for commit view',
      });
      return;
    }
  }
  const opts =
    repoRel && view === 'commit' && commitSha
      ? {
          repoRelPath: repoRel,
          basis: { kind: 'commit' as const, sha: commitSha },
          recentCommitsLimit,
        }
      : repoRel
        ? { repoRelPath: repoRel, basis: { kind: 'working' as const }, recentCommitsLimit }
        : recentCommitsLimit !== undefined
          ? { recentCommitsLimit }
          : undefined;
  const repos = await getSessionWorkingTreeChangeDetailsCoalesced(
    deps.sessionWorktreeManager,
    msg.sessionId,
    opts,
  );
  reply({ ok: true, repos }, ['repos']);
}
